module.exports = __webpack_public_path__ + "static/media/vote-form-img-white.57b93b6a.png";